import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Consultancy.css'
import consultancyHero from "../../../assets/images/Civil Consultancy.png";
import consultancyProcess from "../../../assets/images/Civil Consultancy.png";

const ConsultancyPage = () => {
  return (
    <>
    <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Construction Consultancy – BuddyTech Solutions </title>
        <meta name="description" content="Expert pre-construction feasibility, risk mitigation and quality audits." />
        <meta name="keywords" content="construction consultant, feasibility study" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Construction Consultancy – BuddyTech Solutions" />
        <meta property="og:description" content="Expert pre-construction feasibility, risk mitigation and quality audits." />
        <meta property="og:keywords" content="construction consultant, feasibility study" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/constructions/consultancy" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Construction Consultancy – BuddyTech Solutions" />
        <meta name="twitter:description" content="Expert pre-construction feasibility, risk mitigation and quality audits." />
        <meta name="twitter:keywords" content="construction consultant, feasibility study" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
 </Helmet>
    <div className="consultancy-container">
      <header className="consultancy-hero">
        <div className="consultancy-hero-content">
          <h1>Construction Consultancy Services</h1>
          <p>
            We guide your projects from concept to completion with expert advice, strategic planning, and technical insight for maximum success.
          </p>
        </div>
        <img src={consultancyHero} alt="Consultancy Hero" className="consultancy-hero-img" />
      </header>

      <section className="consultancy-section">
        <div className="consultancy-text">
          <h2>Our Expertise</h2>
          <p>
            Our consultancy services empower clients with decision-making confidence and project clarity through professional analysis and tailored recommendations.
          </p>
          <ul>
            <li>Pre-construction Feasibility Studies</li>
            <li>Regulatory & Compliance Guidance</li>
            <li>Value Engineering & Cost Control</li>
            <li>Quality Assurance & Project Audits</li>
            <li>Contract Management & Risk Mitigation</li>
          </ul>
        </div>
        <img src={consultancyProcess} alt="Consultancy Process" className="consultancy-img" />
      </section>

      <section className="consultancy-tools">
        <h2>Tools & Platforms We Use</h2>
        <div className="tools-grid">
          <span>AutoCAD</span>
          <span>Revit</span>
          <span>MS Excel</span>
          <span>Primavera</span>
          <span>MS Project</span>
          <span>Navisworks</span>
          <span>Building Codes & IS Standards</span>
          <span>GIS & Environmental Data</span>
        </div>
      </section>
      <section className="contact-options">
        <div className="contact-card email">
          <h2>📧 Email</h2>
          <p>Send us an email for inquiries, support or collaboration opportunities.</p>
          <a href="mailto:vinujaya.v7@gmail.com" target="_blank" rel="noopener noreferrer">
            Send Email 
          </a>
        </div>

        <div className="contact-card whatsapp">
          <h2>💬 WhatsApp</h2>
          <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
          <a href="https://wa.me/917010658911" target="_blank" rel="noopener noreferrer">
            Chat on WhatsApp
          </a>
        </div>

        <div className="contact-card phone">
          <h2>📞 Call Us</h2>
          <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
          <a href="tel:+917010658911">Call Us</a>
        </div>
      </section>
    </div>
    </>
  );
};

export default ConsultancyPage;